import type { ReactElement, ReactNode } from "react";
import { Tab, TabbedShowLayoutProps, TabProps } from "react-admin";
import { NewDesignTabbedShowLayout } from "./NewDesignTabbedShowLayout";

type TabElement = ReactElement<TabProps, typeof Tab>;

type TabsProps = {
  header?: ReactNode;
  additionalButtons?: ReactNode;
  children: Array<TabElement | false | undefined | null>;
  syncWith: "path" | "hash" | "none";
  onTabChange?: (activeTab: ReactElement) => void;
} & Omit<TabbedShowLayoutProps, "tabs">;

export function Tabs2(props: TabsProps) {
  const { header, additionalButtons, syncWith, children, ...rest } = props;
  return (
    <NewDesignTabbedShowLayout
      header={header}
      additionalButtons={additionalButtons}
      tabs={children}
      syncWithLocation={syncWith === "path"}
      syncWithHash={syncWith === "hash"}
      contentPadding={0}
      tabsButtonsSpacing={0}
      sx={{
        borderRadius: 0,
        backgroundColor: "transparent",
        backgroundImage: "none",
        "& .MuiTabs-root": {
          minHeight: "50px",
        },
        "& .MuiTab-root": {
          width: "156px",
          height: "50px !important",
          borderRadius: "16px 16px 0 0",
          backgroundColor: "action.hover",
          "&:not(.Mui-selected):hover": {
            backgroundColor: "action.selected",
          },
          "&.Mui-selected": {
            backgroundColor: "background.paper",
            color: "text.secondary",
          },
        },
      }}
      {...rest}
    />
  );
}
